module.exports = "<p>\n  normaldevice works!\n</p>\n"